export default "__VITE_ASSET__BFx7F8t2__"